"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Group as Group$1, Stack } from "@mantine/core";
import { forwardRef } from "react";
const _Group = forwardRef((props, ref) => {
  const {
    children,
    grow,
    wrap = "wrap",
    className,
    justify = "left",
    spacing = "xs",
    direction = "row",
    align = "normal",
    style,
    ...rest
  } = props;
  if (direction === "row") {
    return /* @__PURE__ */ jsx(
      Group$1,
      {
        ...rest,
        align,
        justify,
        grow,
        wrap,
        gap: spacing,
        ref,
        className,
        style,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Stack,
    {
      ...rest,
      gap: spacing,
      ref,
      className: `${className}`,
      align,
      justify,
      style,
      children
    }
  );
});
_Group.displayName = "Group";
const Group = sharedHandler(_Group);
Group.displayName = _Group.displayName;
export {
  Group as default
};
